import React from 'react';
import { FileOrFormQuestion } from '../FileOrFormQuestion';
import { usePropertyPurchaseContractFile } from '../../../../queries/PropertyFileFields/RentalFiles';

interface PurchaseContractFileParameter {
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const PurchaseContractFile: React.FC<PurchaseContractFileParameter> = ({ propertyGuid, required, isReview = false }) => {
    const { handleMode, setHandleMode, filename: uploadFileName, setFilename: setUploadFileName, fileApiId: uploadedFileApiId, setFileApiId: setUploadedFileApiId } = usePropertyPurchaseContractFile(propertyGuid);

    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    label='Purchase contract'
                    selector='purchaseContract'
                    fileType='purchase contract'
                    required={required}
                    isReview={isReview}
                    propertyGuid={propertyGuid}
                    handle={handleMode}
                    onHandleChange={setHandleMode}
                    uploadFileName={uploadFileName}
                    onUploadFileNameChange={setUploadFileName}
                    uploadedFileApiId={uploadedFileApiId}
                    onUploadedFileApiIdChange={setUploadedFileApiId}
                />
            </div>
        </div>
    );
};
